
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as mainxnFi6GOT2XiQyExVgzWxcrF2pCgn8Ja3r3bQUbcpudkMeta } from "/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/main.vue?macro=true";
import { default as group86Ih84Obd1U_45K_453uKVjie576nW1__45uIJdkL8wG3yGrcMeta } from "/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/group.vue?macro=true";
import { default as indexk55ODEPzyCJFJlyQPGqhjU2zmWjEHnGnNi7Y1kzT8HIMeta } from "/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/index.vue?macro=true";
import { default as termskaImuRvsZbvmlGy9TE2CDSyBlwnlBnUS5_gMiPRzbaUMeta } from "/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/terms.vue?macro=true";
import { default as moichatVngd7zHcyFOH_45z4fAav1wMuJ_45XG_45_gkZWkpRQS3au7sMeta } from "/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/moichat.vue?macro=true";
import { default as privacyKqMHCfs8lzy0JlkkSy3W8K4Z13Ui86X628saZ8LB_45FoMeta } from "/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/privacy.vue?macro=true";
import { default as welcomexl7c3t8fKt0iLsgRIYHzVIvqcSQcMyeAoAYnpFUnF2gMeta } from "/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/welcome.vue?macro=true";
import { default as settingsFn43z49zXl3o2d_M_45wWSqkI7JeG4COdECW10CAIHUx8Meta } from "/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/settings.vue?macro=true";
import { default as _91id_93x9s0LiPSLMUl2xlfDgvvViWzzjJEwcOd7npXN9eQkgAMeta } from "/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/confirm/[id].vue?macro=true";
import { default as _91roomId_93_CZfilfEyzv08lWYFT3JTe_45Hi8v4Mp4WIMpR9E9s8uUMeta } from "/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/chat/[roomId].vue?macro=true";
import { default as apple_45callbackf4gZVrF5M2nrRWdQwdAOMkThvyb95uOUnBTz7DY2mT4Meta } from "/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/apple-callback.vue?macro=true";
import { default as kakao_45callback81OtCqPN0gIplJPc440wnTT0rTChb_45rYFnNaEZf33cAMeta } from "/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/kakao-callback.vue?macro=true";
export default [
  {
    name: "main",
    path: "/main",
    component: () => import("/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/main.vue")
  },
  {
    name: "group",
    path: "/group",
    meta: {"middleware":"auth"},
    component: () => import("/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/group.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/terms.vue")
  },
  {
    name: "moichat",
    path: "/moichat",
    component: () => import("/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/moichat.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/privacy.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    component: () => import("/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/welcome.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/settings.vue")
  },
  {
    name: "confirm-id",
    path: "/confirm/:id()",
    component: () => import("/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/confirm/[id].vue")
  },
  {
    name: "chat-roomId",
    path: "/chat/:roomId()",
    component: () => import("/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/chat/[roomId].vue")
  },
  {
    name: "apple-callback",
    path: "/apple-callback",
    meta: apple_45callbackf4gZVrF5M2nrRWdQwdAOMkThvyb95uOUnBTz7DY2mT4Meta || {},
    component: () => import("/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/apple-callback.vue")
  },
  {
    name: "kakao-callback",
    path: "/kakao-callback",
    meta: kakao_45callback81OtCqPN0gIplJPc440wnTT0rTChb_45rYFnNaEZf33cAMeta || {},
    component: () => import("/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/pages/kakao-callback.vue")
  }
]